module.exports = __webpack_public_path__ + "img/waistline back pocket position.1fb0e126.png";